import TextfieldIntControlled, {
  TextfieldIntControlledProps } from
"./TextfieldIntControlled";
import Spinner from "../Spinner/Spinner";
import Icon from "../Icon/Icon";import Tooltip from "@/Components/Tooltip/Tooltip";

interface Props extends Omit<TextfieldIntControlledProps, "value"> {
  isPending: boolean;
  onClick: () => void;
  value: {[key: string]: string;} | undefined;
  tooltipContent?: string;
}

const TextfieldWithAi = ({
  name,
  label,
  defaultValue = {},
  placeholder,
  isPending,
  onClick,
  value,
  tooltipContent,
  ...rest
}: Props) => {
  return (
    <TextfieldIntControlled
      label={label}
      placeholder={placeholder || label}
      name={name}
      defaultValue={value ?? defaultValue}
      isRightAddonClickable
      onClickRightAddon={onClick}
      inputRightAddon={
      isPending ?
      <Spinner size="0.18rem" /> : <Tooltip content=



      {tooltipContent}><div><Icon
            className="h-[1.9rem] w-[1.9rem] fill-primary"
            variants="aiGenerate" /></div></Tooltip>


      }
      {...rest} />);


};

export default TextfieldWithAi;